var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94233 15.5C1.55018 15.5 1.21175 15.3576 0.92705 15.0729C0.64235 14.7882 0.5 14.4498 0.5 14.0576V1.94232C0.5 1.55017 0.64235 1.21175 0.92705 0.92705C1.21175 0.64235 1.55018 0.5 1.94233 0.5H18.0576C18.4498 0.5 18.7882 0.64235 19.0729 0.92705C19.3576 1.21175 19.5 1.55017 19.5 1.94232V14.0576C19.5 14.4498 19.3576 14.7882 19.0729 15.0729C18.7882 15.3576 18.4498 15.5 18.0576 15.5H1.94233ZM9.99998 8.15187L1.6346 2.61535V14.0576C1.6346 14.1474 1.66345 14.2211 1.72115 14.2788C1.77885 14.3365 1.85258 14.3654 1.94233 14.3654H18.0576C18.1474 14.3654 18.2211 14.3365 18.2788 14.2788C18.3365 14.2211 18.3654 14.1474 18.3654 14.0576V2.61535L9.99998 8.15187ZM9.99998 6.9596L18.1404 1.6346H1.8846L9.99998 6.9596ZM1.6346 2.61535V1.6346V14.0576C1.6346 14.1474 1.66345 14.2211 1.72115 14.2788C1.77885 14.3365 1.85258 14.3654 1.94233 14.3654H1.6346V2.61535Z",
    fill: "#617380"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.0799c4dc.svg";
export { ForwardRef as ReactComponent };